import { AggregateFunctionName, RunResultsAggregate } from "@custom-types/modelRun"
import { AggregatedResult } from "@features/results/Result/AggregateFunctionChart"

const aggregateFunctionAliases: Partial<Record<string, AggregateFunctionName>> = {
  "5th_quantile": "quantile_5th",
  "10th_quantile": "quantile_10th",
  "25th_quantile": "quantile_25th",
  "50th_quantile": "quantile_50th",
  "75th_quantile": "quantile_75th",
  "90th_quantile": "quantile_90th",
  "95th_quantile": "quantile_95th",
}

const getAggregateResultKey = (aggregateFunction: AggregateFunctionName) => {
  return aggregateFunctionAliases[aggregateFunction] ?? aggregateFunction
}

export const getTimesteps = (
  runsResults: RunResultsAggregate | undefined,
  lagShift: number,
): string[] => {
  if (!runsResults) return []

  const labels: string[] = []

  Object.entries(runsResults).forEach(([_runKey, singleRunResults]) => {
    Object.entries(singleRunResults).forEach(([_nodeName, nodeResult]) => {
      if (!nodeResult?.timesteps) return
      labels.push(...Object.keys(nodeResult.timesteps).slice(lagShift))
    })
  })

  return Array.from(new Set(labels)).sort()
}

export const getResults = (
  runsResults: RunResultsAggregate | undefined,
  lagShift: number,
  aggregationFunctions: AggregateFunctionName[],
): AggregatedResult[][] => {
  if (!runsResults) return []

  const timesteps = getTimesteps(runsResults, lagShift)
  const results: AggregatedResult[][] = []

  Object.entries(runsResults).forEach(([_runKey, singleRunResults]) => {
    Object.entries(singleRunResults).forEach(([_nodeName, nodeResult]) => {
      if (!nodeResult?.timesteps) return
      aggregationFunctions.forEach((aggregateFunction) => {
        const aggregateResultKey = getAggregateResultKey(aggregateFunction)
        let aggregateResults = results.find((result) => result[0]?.key === aggregateFunction)
        if (!aggregateResults) {
          aggregateResults = []
          results.push(aggregateResults)
        }

        aggregateResults.push({
          key: aggregateFunction,
          timesteps,
          data: timesteps.map(
            (timestep) => nodeResult.timesteps[timestep]?.[aggregateResultKey] ?? null,
          ),
        })
      })
    })
  })

  return results
}
